<script setup lang="ts">
import KBtn from '@/components/btns/KBtn.vue';

export interface Props {
  isOver?: boolean;
  isDisabled?: boolean;
  isMultiple?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isOver: false,
  isDisabled: false,
  isMultiple: true,
});

const emit = defineEmits<{
  open: [];
}>();

function handleOpenClick(): void {
  if (props.isDisabled) return;
  emit('open');
}
</script>

<template>
  <div
    :class="[
      $style.dropZoneButton,
      {
        [$style.disabled]: props.isDisabled,
        [$style.over]: props.isOver && !props.isDisabled,
      },
    ]"
    data-testid="dropZoneButton"
  >
    <div :class="$style.content">
      <KBtn
        :class="$style.btn"
        priority="info"
        :disabled="props.isDisabled"
        @click="handleOpenClick"
      >
        Choose
        <template v-if="props.isMultiple">files</template>
        <template v-else>a file</template>
      </KBtn>
      {{ ' ' }}
      <span :class="{ [$style.disabledText]: props.isDisabled }">
        or drop here
      </span>
    </div>
    <div :class="{ [$style.disabledText]: props.isDisabled }">
      <v-icon icon="mdi-tray-arrow-up" :class="$style.icon"></v-icon>
    </div>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.dropZoneButton {
  border: 1px dashed colors.$color-brand-300;
  min-height: 74px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
}
.disabled {
  border: 1px dashed colors.$color-text-tertiary;
  cursor: not-allowed;
}
.over {
  background: colors.$color-brand-50;
}
  .disabledText {
    color: colors.$color-text-tertiary;
  }
  .content {
  }
    .btn {
      vertical-align: baseline;
      margin-right: 4px;

      :global {
        .v-btn__content {
          text-transform: none;
        }
      }
    }
  .icon {
    font-size: 24px;
  }
</style>
